import { Reveal, SectionEyebrow } from "./Reveal";
import { SERVICES } from "../../data";
import { ArrowRight } from "lucide-react";
import { openInquiry } from "../../lib/inquiry";

export const Services = () => (
  <section id="services" className="bg-oyf-grey py-20 md:py-28" data-testid="services">
    <div className="container-oyf">
      <div className="max-w-3xl">
        <SectionEyebrow>Expedited Freight Services</SectionEyebrow>
        <h2 className="font-display font-extrabold text-oyf-black tracking-tight text-3xl md:text-5xl leading-[1.02]">
          Flexible Transportation Built Around Your Shipment
        </h2>
        <p className="mt-5 text-oyf-medgrey text-base md:text-lg leading-relaxed">
          From urgent production parts to scheduled commercial deliveries, One York Freight coordinates cargo-van transportation according to the shipment&apos;s route, dimensions, timing and handling requirements.
        </p>
      </div>

      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => (
          <Reveal key={s.t} delay={(i % 3) * 0.08}>
            <div className="h-full bg-white rounded-lg p-6 border border-oyf-grey shadow-sm" data-testid={`service-card-${i}`}>
              <span className="font-display font-extrabold text-oyf-yellow text-4xl leading-none">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="font-display font-bold text-oyf-black text-lg mt-4 leading-snug">{s.t}</h3>
              <p className="text-sm text-oyf-medgrey mt-2 leading-relaxed">{s.d}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-12 flex justify-center">
        <button onClick={() => openInquiry("Services CTA")} className="inline-flex items-center gap-2 bg-oyf-charcoal text-white font-bold px-7 py-4 rounded-md hover:bg-oyf-black hover:-translate-y-0.5 transition-all duration-200" data-testid="services-cta">
          Discuss Your Shipment <ArrowRight size={18} className="text-oyf-yellow" />
        </button>
      </div>
    </div>
  </section>
);
